export const sum = (numbers) =>
  numbers.reduce((partialSum, a) => partialSum + (a || 0), 0);

export const roundNumber = (number, decimalPlaces = 2) => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
};

export const asNegative = (number) => (number > 0 ? -number : number);

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 * Reference: https://stackoverflow.com/a/1527820
 */
export const getRandomInt = (min = 0, max = 100) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * Round down to the nearest 5.
 * @param {number}
 * @returns {number}
 */
export const roundDownToNearest5 = (num) => {
  // num / 5: Convert the number into “groups of 5.”
  // Math.floor(...): Round down to the nearest whole group.
  // Multiply by 5 again: Convert the “group count” back to an actual number ending in 0 or 5.
  return Math.floor(num / 5) * 5;
};

/**
 * Round up to the nearest 5.
 * @param {number}
 * @returns {number}
 */
export const roundUpToNearest5 = (num) => {
  // Make the output to be the smallest multiple of 5 that is greater than or equal to num.
  return Math.ceil(num / 5) * 5;
};
